
import React, { useEffect } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import CrfTabContent from './CrfTabContent';
import { Box, Grid, Tab, Tabs, Typography, AppBar, Toolbar, Button } from '@material-ui/core';
import DataClient from '../../../../../../Service/general_data_service';
import moment from "moment";

const useStyles = makeStyles((theme) => ({
    tabRoot: {
        '& .MuiTabs-flexContainer': {
            justifyContent: "flex-start"
        },
        '& .MuiTabs-indicator': {
            backgroundColor: "transparent"
        }
    },
    tabs: {
        color: "#1e1e1e",
        borderWidth: 1,
        borderStyle: "solid",
        borderColor: "#ddd",
        backgroundColor: "rgba(7,127,131,.75)",
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5,
        marginRight: 10,
        // fontSize: "18px",
        minWidth: 130,
        textTransform: "none",
        "&:hover,&.Mui-selected": {

            color: "#fff",
            backgroundColor: "rgba(7,127,131,1)",
            opacity: 1
        }
    },
    overviewContainer: {
        position: 'sticky', top: 64, paddingTop: 40, background: '#fff', zIndex: 1
    },
    appBar: {
        backgroundColor: "#fff",
        color: '#232323',
        boxShadow: "0px 3px 6px #232323",
        marginBottom: '2rem'
    }
}));

export default function Crf(props) {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [pageData, setPageData] = React.useState({});
    const [receivedDate,setReceivedDate] = React.useState("")

    function TabPanel(props) {
        const { children, value, index, option, ...other } = props;
        return (
            <Box role="tabpanel" hidden={value !== index} id={`full-width-tabpanel-${index}`} aria-labelledby={`full-width-tab-${index}`} {...other}>
                {value === index && <CrfTabContent pageData={option.crf_fields} />}
            </Box>
        );
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    useEffect(() => {
        getData();
    }, [])

    const getData = (params) => {
        DataClient.getData('crf_users/view_crf?coaching_request_form_id=' + props.coaching_request_form_id + '&crf_user_id=' + props.crf_user_id)
            .then((res) => {
                pageData.length = 0;
                setPageData({ ...pageData, ...res.coaching_request_form })
                const crfReceived =moment( res.coaching_request_form?.submitted_at?.split(' ')[0]).format("MM/DD/YYYY")
                setReceivedDate(crfReceived);
            })
    }
    return <>
        <Grid container direction="row" justify="center" alignItems="center">
            <Grid item xs={11} style={{ textAlign: "center" }} direction="row" justify="center" alignItems="center" className={classes.overviewContainer}>
                <AppBar position="static" className={classes.appBar} elevation={0}>
                    <Toolbar>
                        <Grid container direction="row" justify="left" alignItems="left" xs={12}>
                            <Grid item xs={6}>
                                <Typography variant="h1" style={{ color: "#4A4A4A" }}>
                                    <Box textAlign="left" fontWeight="fontWeightBold">Coaching request form</Box>
                                    {pageData?.submitted_at && <Box textAlign="left" style={{ fontSize: "15px", lineHeight: "22px", fontFamily: "Open Sans" }} > Received on {receivedDate}</Box>}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Toolbar>
                </AppBar>
            </Grid>

            <Grid item xs={11}>
                {
                    pageData?.crf_form_sections?.length > 0 &&
                    <Box mb={5}>
                        <Tabs value={value}  variant="scrollable"
                    scrollButtons="auto" onChange={handleChange} classes={{ root: classes.tabRoot }}>
                            {
                                pageData?.crf_form_sections.filter(
                                    (selected_field) =>
                                        selected_field.section_name !== "Description").map((option) => <Tab classes={{ root: classes.tabs }} label={option.section_name} />)
                            }
                        </Tabs>
                        {
                            pageData?.crf_form_sections.filter(
                                (selected_field) =>
                                    selected_field.section_name !== "Description").map((option, index) => <TabPanel value={value} option={option} index={index}>{option}</TabPanel>)
                        }
                    </Box>
                }
            </Grid>
        </Grid>
    </>



}



